import { RouteConfig } from 'vue-router';
import TpmAnalytics from './pages/TpmAnalytics.vue';
import TpmAnalyticsDashboard from './pages/TpmAnalyticsDashboard.vue';
import TpmAnalyticsOee from './pages/TpmAnalyticsOee.vue';
import TpmAnalyticsMaintenance from './pages/TpmAnalyticsMaintenance.vue';
import TpmAnalyticsScrapAnalysis from './pages/TpmAnalyticsScrapAnalysis.vue';
import TpmAnalyticsFinancialImpact from './pages/TpmAnalyticsFinancialImpact.vue';
import TpmAnalyticsTrends from './pages/TpmAnalyticsTrends.vue';
import TpmAnalyticsProduction from './pages/TpmAnalyticsProduction.vue';
import TpmAnalyticsPlanFulfillment from './pages/TpmAnalyticsPlanFulfillment.vue';

export default [
    {
        path: '/:tenantId/tpm-analytics',
        name: 'TpmAnalytics',
        component: TpmAnalytics,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            checkLicence: true,
            title: 'menu.tpmAnalytics',
        },
        children: [
            {
                path: '/:tenantId/tpm-analytics/dashboard',
                name: 'TpmAnalyticsDashboard',
                component: TpmAnalyticsDashboard,
                props: (route) => ({ tenantId: route.params.tenantId }),
                meta: {
                    checkLicence: true,
                    title: 'menu.tpmAnalytics',
                },
            },
            {
                path: '/:tenantId/tpm-analytics/oee',
                name: 'TpmAnalyticsOee',
                component: TpmAnalyticsOee,
                props: (route) => ({ tenantId: route.params.tenantId }),
                meta: {
                    checkLicence: true,
                    title: 'menu.tpmAnalytics',
                },
            },
            {
                path: '/:tenantId/tpm-analytics/maintenance',
                name: 'TpmAnalyticsMaintenance',
                component: TpmAnalyticsMaintenance,
                props: (route) => ({ tenantId: route.params.tenantId }),
                meta: {
                    checkLicence: true,
                    title: 'menu.tpmAnalytics',
                },
            },
            {
                path: '/:tenantId/tpm-analytics/scrap-analysis',
                name: 'TpmAnalyticsScrapAnalysis',
                component: TpmAnalyticsScrapAnalysis,
                props: (route) => ({ tenantId: route.params.tenantId }),
                meta: {
                    checkLicence: true,
                    title: 'menu.tpmAnalytics',
                },
            },
            {
                path: '/:tenantId/tpm-analytics/financial-impact',
                name: 'TpmAnalyticsFinancialImpact',
                component: TpmAnalyticsFinancialImpact,
                props: (route) => ({ tenantId: route.params.tenantId }),
                meta: {
                    checkLicence: true,
                    title: 'menu.tpmAnalytics',
                },
            },
            {
                path: '/:tenantId/tpm-analytics/trends',
                name: 'TpmAnalyticsTrends',
                component: TpmAnalyticsTrends,
                props: (route) => ({ tenantId: route.params.tenantId }),
                meta: {
                    checkLicence: true,
                    title: 'menu.tpmAnalytics',
                },
            },
            {
                path: '/:tenantId/tpm-analytics/production',
                name: 'TpmAnalyticsProduction',
                component: TpmAnalyticsProduction,
                props: (route) => ({ tenantId: route.params.tenantId }),
                meta: {
                    checkLicence: true,
                    title: 'menu.tpmAnalytics',
                },
            },
            {
                path: '/:tenantId/tpm-analytics/plan-fulfillment',
                name: 'TpmAnalyticsPlanFulfillment',
                component: TpmAnalyticsPlanFulfillment,
                props: (route) => ({ tenantId: route.params.tenantId }),
                meta: {
                    checkLicence: true,
                    title: 'menu.tpmAnalytics',
                },
            },
        ],
    },
] as RouteConfig[];


